const SYMBOL = {
  PLACEHOLDER: '###',
  ACTION: '>>>',
  SEPARATOR: '|',
  NOT: '>>>NOT>>>',
  OR: '>>>OR>>>',
  FROM: '>>>FROM>>>',
  TO: '>>>TO>>>',
};

export default SYMBOL;
